@if (formGroup) {
    <div class="flex flex-col gap-7 justify-between" style="height: 100%">
        <form [formGroup]="$any(formGroup)" class="flex flex-col gap-7">
            <!-- <z-product-department-select
            formControlName="ParentId"
        ></z-product-department-select> -->
            <z-pos-terminals-select
                [(ngModel)]="selectedPOSterminalId"
                (ngModelChange)="onSelectPOSTerminal($event)"
                [ngModelOptions]="{ standalone: true }"
            ></z-pos-terminals-select>
            <!-- <p-floatlabel class="w-full md:w-80">
            <p-treeselect
                class="w-full"
                style="width: 100%"
                [(ngModel)]="selectedNode"
                (onNodeSelect)="onNodeSelect($event)"
                (onNodeUnselect)="onNodeUnselect($event)"
                [options]="nodes"
                placeholder="Επιλέξτε Γονικό Τμήμα Προϊόντων"
                [showClear]="true"
                title="Επιλέξτε το Τμήμα ΠροΪόντων κάτω από το οποίο θα υπάγεται το νέο Τμήμα Προϊοντων που θα καταχωρήσετε. Αν η καταχωρήση σας αφορά Αρχικό Τμήμα, τότε αφήστε το πεδίο κενό."
            />
            <label for="over_label">Τμήμα Προϊόντων</label>
        </p-floatlabel> -->
            <z-float-label
                [label]="'Τίτλος'"
                formControlName="Title"
            ></z-float-label>

            <z-float-label
                [label]="'Terminal Id'"
                formControlName="TerminalId"
            ></z-float-label>
            <z-float-label [label]="'I.P'" formControlName="IP"></z-float-label>
            <z-float-label
                [label]="'Port'"
                formControlName="Port"
            ></z-float-label>
            <!-- <z-vat-categories-select
            [showLabel]="true"
            formControlName="VATCategoryId"
        ></z-vat-categories-select> -->
        </form>

        <div class="flex grow flex-wrap gap-4 justify-between items-end">
            <!-- <p-button label="Ακύρωση" severity="secondary" /> -->
            <div></div>

            <p-button label="Αποθήκευση" (onClick)="savePOSTerminal()" />
        </div>
    </div>
}
